import { useEffect, useState } from "react";
import { back } from "../Api/ApiUrl";
import instance from "../Api/Instance";

const initialImeiDetailsState = {
  imei: undefined,
  material: undefined,
  size: undefined,
  sapCode: undefined,
  width: undefined,
  height: undefined,
  length: undefined,
  weight: undefined,
};

export default function useImei() {
  const [imeiDetails, setImeiDetails] = useState(initialImeiDetailsState);
  const getImeiInfo = async (imeiValue, materialType = 1) => {
    setImeiDetails(initialImeiDetailsState);
    try {
      const response = await instance.get(
        `${back.getImeiInfo}/${imeiValue}?materialType=${materialType}`
      );
      if (response?.status === 200) {
        setImeiDetails({ ...response?.data });
        return response?.data;
      }

      setImeiDetails(initialImeiDetailsState);
      return false;
    } catch (error) {
      setImeiDetails(initialImeiDetailsState);
      console.error(error);
      return false;
    }
  };

  return { getImeiInfo, imeiDetails };
}
